import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import Footer from '../../../../../components/footer'
import Head from '../../../../../components/head';
import FormCad from '../../../../../components/auth/rh/terceirizados/form_cad'


function CadastrarTerceirizadosScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar Terceirizado - Recursos Humanos" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarTerceirizadosScreen;